<template>
<div class="comparison">

  <table>
    <thead>
       <tr>
         <th class="tl" style="border-style: none"></th>
         <th class="compare-heading leftside">Basic</th>
         <th class="compare-heading compare-image" rowspan="2">Standard</th>
         <th class="compare-heading rightside">Advance</th>
      </tr>
      <tr>
         <th class="tl" style="border-style: none"></th>
         <th style="border-left: 1px solid #CCC; border-bottom: none;"> &nbsp;</th>
         <th style="border-right: 1px solid #CCC; border-bottom: none;"> &nbsp;</th>

      </tr>
      <tr>
        <th></th>
        <th class="price-info">
          <div class="price-was">Was €99.00</div>
          <div class="price-now"><span>€79<span class="price-small">.50</span></span> /month</div>
          <div><a href="#" class="price-buy">Buy <span class="hide-mobile">Now</span></a></div>
          <div class="price-try"><span class="hide-mobile">or </span><a href="#">try <span class="hide-mobile">it free</span></a></div>
        </th>
        <th class="price-info">
          <div class="price-was">Was €159.00</div>
          <div class="price-now"><span>€119<span class="price-small">.50</span></span> /month</div>
          <div><a href="#" class="price-buy">Buy <span class="hide-mobile">Now</span></a></div>
          <div class="price-try"><span class="hide-mobile">or </span><a href="#">try <span class="hide-mobile">it free</span></a></div>
        </th>
        <th class="price-info">
          <div class="price-was">Was €189.00</div>
          <div class="price-now"><span>€159<span class="price-small">.50</span></span> /month</div>
          <div><a href="#" class="price-buy">Buy <span class="hide-mobile">Now</span></a></div>
          <div class="price-try"><span class="hide-mobile">or </span><a href="#">try <span class="hide-mobile">it free</span></a></div>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr class="compare-row" v-for="item in features" :key="item.no">
        <td v-if="item.category == 'title'" colspan="4" class="compare-category"> {{item.feature}}</td>
        <td v-if="item.category != 'title'"><span v-html="item.feature"></span></td>
        <td v-if="item.category != 'title'"><span class="tickblue">{{ toShow(item.basic) }}</span></td>
        <td v-if="item.category != 'title'"><span class="tickblue">{{ toShow(item.standard) }}</span></td>
        <td v-if="item.category != 'title'"><span class="tickblue">{{ toShow(item.advance) }}</span></td>
      </tr>
    </tbody>
  </table>
  <div style="dispaly:inline-flex">
   <div class="transmitter">
      * Bluetooth transmitter sold separately	<br />
      it is highly recommended to use such a transmitter to take advantage of all the tracking option our app has. <br />
      It is possible to get a bluetooth enable scale adapter instead. <a href="#">Compitable list</a>
   </div>
   <div class="transmitter-buy">
      <img src="../assets/bt-adapter.jpg" alt="Bluetooth scale adapter" class="transmitter-image">
      <h3>Bluetooth scale adapter</h3>
      <div class="price-now"><span>€59<span class="price-small">.95</span></span></div>
      <div><a href="#" class="price-buy">Buy Now</a></div>
   </div>
  </div>

</div>
</template>

<script>
import features from './features';
export default {
   data() {
//#region Data
      return {
         headers: [
            //{ text: "-", align: "start", value: "category" },
            //{ text: "-", align: "start", width: "40%", value: "feature" },
            { text: 'Basic', align: "center", width: "20%", value: "basic" },
            { text: 'Standard', align: "center", width: "20%", value: "standard" },
            { text: 'Advance', align: "center", width: "20%", value: "advance" },
         ]
      }
   },
//#endregion
computed: {
   features() {
      return features.features();
   }
},
methods: {
   toShow(value) {
      if (typeof value == "boolean")
         return value ? "✔" : "";
      else
         return value;
      },
   },
}
</script>

<style scoped>
.comparison {
  max-width:1024px;
  margin:0 auto;
  font:13px/1.4 "Helvetica Neue",Helvetica,Arial,sans-serif;
  text-align:center;
  padding:10px;
}

.comparison table {
  width:100%;
  border-collapse: collapse;
  border-spacing: 0;
  table-layout: fixed;
  border-bottom:1px solid #CCC;
}

.comparison td, .comparison th {
  border-right:1px solid #CCC;
  empty-cells: show;
  padding:10px;
}

.compare-image {
   background-image: url(../assets/popular.png);
   background-size: contain;

}

.compare-heading {
  font-size:24px;
  font-weight:bold !important;
  color: yellow;
  border-bottom:0 !important;
  border-right:0  !important;;
  padding-top:16px !important;
  padding-bottom:16px !important;
  background-color: #607d8b;
}
.leftside {
   border-radius: 20px 0px 0px 0px;
}

.rightside {
   border-radius: 0px 20px 0px 0px
}

.compare-heading-middle {
  font-size:24px;
  font-weight:bold !important;
  color: palegoldenrod;
  border-bottom:0 !important;
  padding-top:24px !important;
  padding-bottom:24px !important;
  background-color: slategray;
}

.compare-category {
  font-size:16px;
  color: #ffffff;
  font-weight:500 !important;
  border-bottom:0 !important;
  padding:6px 20px!important;
  background-color: #477c00;
}

.comparison tbody tr:nth-child(odd) {
  background-color: #dddddd;
}

.comparison .compare-row {
  background:#F5F5F5;
  white-space: wrap;
}

.comparison .tickblue {
  color:#0078C1;
  font-size: 16px;
}

.comparison .tickgreen {
  color:#009E2C;
}

.comparison th {
  font-weight:normal;
  padding:0;
  border-bottom:1px solid #CCC;
}

.comparison tr td:first-child {
  text-align: left;
}

.comparison .tl {
  border-right:0;
  width: 40%;
}

.comparison .price-info {
  padding:5px 15px 15px 15px;
  text-align: center;
}

.comparison .price-was {
  color:#999;
  text-decoration: line-through;
}

.comparison .price-now, .comparison .price-now span {
  color:#ff5406;
}

.comparison .price-now span {
  font-size:32px;
}

.comparison .price-small {
    font-size: 18px !important;
    position: relative;
    top: -11px;
    left: 2px;
}

.comparison .price-buy {
  background:#ff5406;
  padding:10px 20px;
  font-size:12px;
  display:inline-block;
  color:#FFF;
  text-decoration:none;
  border-radius:3px;
  text-transform:uppercase;
  margin:5px 0 10px 0;
}

.comparison .price-try {
  font-size:14px;
}

.comparison .price-try a {
  color:blue;
}
.transmitter {
   max-width: 50%;
   text-align:start;
   font-size:14px;
   font-size:2vw;
   padding-top: 10px;
   float: left;
}
.transmitter-buy {
   float: right;
   width: 30%;
   height: 100%;
   border: 2px solid blue;
   border-radius: 10px;
   margin: 5px;
}
.transmitter-image {
   width:20%;
   float:right;
   margin: 5px
}

@media (max-width: 767px) {
  .comparison tbody tr:nth-child(odd) {
    display:table-row;
    background:#F7F7F7;
  }
  .comparison .row {
    background:#FFF;
  }
  .comparison td, .comparison th {
    border:1px solid #CCC;
  }
  .price-info {
  border-top:0 !important;

}

}

@media (max-width: 639px) {
  .comparison .price-buy {
    padding:5px 10px;
  }
  .comparison td, .comparison th {
    padding:10px 5px;
  }
  .comparison .hide-mobile {
    display:none;
  }
  .comparison .price-now span {
  font-size:14px;
}

.comparison .price-small {
    font-size: 14px !important;
    top: 0;
    left: 0;
}
  .comparison .price-buy {
    margin-top:10px;
  }
  .compare-heading {
  font-size:13px;
}
}

@media (max-width: 320px) {
   .comparison {
      font-size: 11px;
   }
   .comparison .price-buy {
      padding:5px 10px;
   }
   .comparison td, .comparison th {
      padding:10px 5px;
   }
   .comparison .hide-mobile {
      display:none;
   }
   .comparison .price-now span {
      font-size:12px;
   }
   .comparison .tickblue {
      color:#0078C1;
      font-size: 12px;
   }
   .comparison .price-small {
      font-size: 12px !important;
      top: 0;
      left: 0;
   }
  .comparison .price-buy {
      margin-top:5px;
   }
   .compare-heading {
     font-size:12px;
   }
}
</style>>
